export default "__VITE_PUBLIC_ASSET__bac9dc9a__"